<template>
	<section class="testimonials py-5 bg-secondary">
		<div class="container">
			<div class="top mb-5">
				<h1 class="text-center">Testimonials</h1>
			</div>
			<div class="row mb-5">
				<div class="col-6">
					<article class="card text-center">
						<div class="card-body">
							<h4>	<i class="fa fa-quote-left mr-2"></i> Anthony Ervin</h4>
							<p>
								I've used this product for years. It's a pleasure to work with
								them.
							</p>
						</div>
					</article>
				</div>
				<div class="col-6">
					<article class="card text-center">
						<div class="card-body">
						
							<h4>	<i class="fa fa-quote-left mr-2"></i> Marcia Gacilos</h4>
							<p>
								Thanks for your assistance in dealing with this matter your service and attention to my concerns were exceptional.  Looking forward to continue working with you in completing my brokerage's appraisals.
								Best Regards,
								HORACE DOCKERY, PRINCIPAL BROKER
							</p>
						</div>
					</article>
				</div>
			</div>
		
		</div>
	
	</section>
</template>

<script>
	export default {
		name: 'Testimonials',
		data () {
			return {}
		}
	}
</script>
